export default "__VITE_PUBLIC_ASSET__c8843c11__"